import React, { useEffect, useState } from 'react';

import Image from 'next/image';
import ConnectWallet from '@/components/connect-wallet';
import LogoMark24Icon from '@/assets/svgs/LogoMark24Icon.svg';

const DesktopHeader = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <div className={`w-full flex flex-row justify-between items-center`}>
      <a href="https://app.mattle.fun/" className={'h-[62px]'}>
        <Image
          src={LogoMark24Icon}
          height={24}
          width={24}
          alt={'i'}
          className={'mx-[24px] mt-[18px] mb-[20px] text-[#F0E9CF]'}
        />
      </a>
      {isClient && <ConnectWallet />}
    </div>
  );
};

const Header = () => {
  return (
    <div className="fixed top-0 left-0 w-full z-[100] ">
      <DesktopHeader />
      <div className={'w-full h-[1px] bg-[#493B0C]'} />
    </div>
  );
};

export default Header;
